import type * as React from 'react';
import type { CurrentUserDto } from '../../../../../../types/UserDtos';
import Link from '../../../../components/Link';
import styles from './style.m.less';

type Props = {
    user: CurrentUserDto;
    iconOnly?: boolean;
};

const Logo: React.FC<Props> = ({ user, iconOnly }) => {
    const { companyLogoId } = user.company.companyDesignSettings;
    const customLogoSrc = companyLogoId && `/imageservice?id=${companyLogoId}&crop=false&size=-1`;
    const customLogoAlt = user.company.name;

    return (
        <Link
            className={iconOnly ? styles.linkIconOnly : styles.link}
            href="/app/home"
            aria-label="Small Improvements Home"
            eventTracking={{ category: 'navigation header', action: 'click logo' }}
            testId="home-link"
        >
            {!customLogoSrc && !iconOnly && (
                <img className={styles.logoFull} src="/images/logo/2020/si-logo-2lines-color.svg" alt="" />
            )}
            {!customLogoSrc && iconOnly && (
                <img className={styles.logoIconOnly} src="/images/logo/2020/si-logomark-color.svg" alt="" />
            )}
            {customLogoSrc && (
                <img
                    alt={customLogoAlt}
                    className={iconOnly ? styles.logoCustomIconOnly : styles.logoCustom}
                    src={customLogoSrc}
                />
            )}
        </Link>
    );
};

export default Logo;
